import React from 'react';
import { Form, Input, Button, Row, Col } from 'antd';
import Select from '../../../components/common/Selection';
import { message } from '../../../components/biz';
import { network, generators, asserts } from '../../../utils';
import api from '../../../config/api';

export default Form.create()(
  React.forwardRef(({ form, formData }, ref) => {
    const { getFieldDecorator, getFieldValue, setFieldsValue } = form;
    const [text, setText] = React.useState(null);
    const [btnLoading, setBtnLoading] = React.useState(false);

    const formItemLayout = {
      labelCol: {
        span: 4,
      },
      wrapperCol: {
        span: 20,
      },
    };

    React.useImperativeHandle(ref, () => ({ ...form }));

    const handleChangeText = (e) => {
      let value = e.target.value;
      setText(value);
    };

    const handleParseAddress = async () => {
      setBtnLoading(true);
      const res = await network({
        url: api.common.recognizeAddress,
        method: 'post',
        data: {
          content: text,
        },
      });
      setBtnLoading(false);
      if (res.success) {
        const { code, data } = res.data.data;
        if (code == 200) {
          let { result = [] } = generators.generatorObject(data);
          let name = Array.isArray(result) && result.length ? result[0].name : '';
          let mobile = Array.isArray(result) && result.length ? result[0].mobile[0] : '';
          let details = Array.isArray(result) && result.length ? result[0].address : '';
          let province = '';
          let city = '';
          let district = '';
          if (Array.isArray(result) && result.length && asserts.isExist(result[0].xzq)) {
            const { xzq } = result[0];
            province = xzq.province;
            city = xzq.city;
            district = xzq.district;
          }
          setFieldsValue({
            shrxm: name,
            phoneNumber: mobile,

            xxdz: province + city + district + details,
          });
        }
        if (code == '10002') {
          message.warn('请求参数错误');
        }
        if (code == '10000') {
          message.warn('解析失败，请检查入参内容是否正确');
        }
        if (code == '30004') {
          message.warn('账号单量不足需要充值');
        }
      } else {
        message.error(res.message);
      }
    };

    return (
      <>
        <Row style={{ marginTop: '20px', position: 'relative' }}>
          <Col offset={4}>
            <Input.TextArea
              placeholder="直接粘贴文字即可智能识别 如：张三，13777877897，浙江省嘉兴市秀洲区塘汇街道昌盛东路浙江嘉兴不锈钢制品股份有限公司"
              maxLength={300}
              rows={5}
              onChange={handleChangeText}
              style={{ width: '80%' }}
              autoSize={{
                minRows: 5,
                maxRows: 5,
              }}
            />
            <Button
              type="primary"
              size="small"
              style={{ position: 'absolute', bottom: '10px', right: '150px' }}
              onClick={handleParseAddress}
              className="btn-info"
              loading={!!btnLoading}
            >
              识别
            </Button>
          </Col>
        </Row>
        <Form
          {...formItemLayout}
          style={{ background: '#fff', padding: '10px 0', marginTop: 5 }}
          className="addAddress"
        >
          <Form.Item label="收货人">
            {getFieldDecorator('shrxm', {
              initialValue: formData.shrxm,
              rules: [{ required: true, message: '请输入收货人' }],
            })(<Input placeholder="请输入收货人" style={{ width: 530 }} />)}
          </Form.Item>
          <Form.Item label="手机号码">
            {getFieldDecorator('phoneNumber', {
              initialValue: formData.sj,
              rules: [
                { required: true, message: '请输入手机号码' },
                {
                  pattern: /^[0-9]{11}$/,
                  message: '请输入11位手机号码',
                },
              ],
            })(<Input placeholder="请输入手机" style={{ width: 530 }} />)}
          </Form.Item>
          <Form.Item label="收货地址">
            {getFieldDecorator('xxdz', {
              initialValue: formData.xxdz,
              rules: [{ required: true, message: '请输入收货地址' }],
            })(<Input placeholder="请输入收货地址" style={{ width: 530 }} />)}
          </Form.Item>
        </Form>
      </>
    );
  }),
);
